/**
 * @generated SignedSource<<fb25188e3c8e35702c4595cc19978b9d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type appStateAdminUserQuery$variables = Record<PropertyKey, never>;
export type appStateAdminUserQuery$data = {
  readonly currentIAMUser: {
    readonly isIAMUser: boolean;
    readonly permissions: ReadonlyArray<string>;
  };
  readonly isAdminUser: boolean;
  readonly seller: {
    readonly sellerID: number;
  } | null;
};
export type appStateAdminUserQuery = {
  response: appStateAdminUserQuery$data;
  variables: appStateAdminUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdminUser",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerID",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CurrentIAMUser",
  "kind": "LinkedField",
  "name": "currentIAMUser",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isIAMUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appStateAdminUserQuery",
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      (v2/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appStateAdminUserQuery",
    "selections": [
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "03df22198b5161a9aee6165a18c152d5",
    "id": null,
    "metadata": {},
    "name": "appStateAdminUserQuery",
    "operationKind": "query",
    "text": "query appStateAdminUserQuery {\n  isAdminUser\n  seller {\n    sellerID\n    id\n  }\n  currentIAMUser {\n    isIAMUser\n    permissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d236340ff70e5e631b2e75d55fd2e79";

export default node;
